<template>
    <v-card>
        <v-card-title>
            <v-btn
                dark
                color="primary"
                class="mb-2"
                :to="{ name: $route.meta.add.route }"
            >
                <v-icon>add</v-icon> {{ $t('departments.list.addItem') }}
            </v-btn>
            <v-divider
                class="mx-3 hidden-md-and-down mt-0"
                inset
                vertical
            ></v-divider>
            <v-text-field
                v-model="search.query"
                @click:clear="clearQuery"
                @keyup.enter="loadData()"
                type="text"
                prepend-icon="search"
                :label="$t('common.search.field')"
                clear-icon="cancel"
                clearable
                hide-details
                solo
            ></v-text-field>

            <v-btn
                class="ml-2"
                color="primary"
                :disabled="!search.ready"
                @click="loadData()"
            >{{ $t('common.search.button') }}</v-btn>
            <v-spacer></v-spacer>
            <!-- <v-switch
                v-if="$route.meta.options.showInatives"
                flat
                inset
                :disabled="!search.ready"
                v-model="dataTable.showInactives"
                :label="$t('common.showInactives')"
            ></v-switch> -->
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-clients',
    metaInfo () {
        return {
            title: this.$t('departments.list.meta.title'),
            meta: [
                { name: 'description', content: this.$t('departments.list.meta.description') },
                { name: 'keywords', content: this.$t('departments.list.meta.keywords') }
            ]
        }
    },
    components: {
        DataTable
    },
    data () {
        return {
            isAdmin: false,
            search: {
                ready: true,
                query: ''
            },
            dataTable: {
                loading: true,
                itemName: this.$t('departments.list.dataTable.itemName'),
                headers: [
                    { text: this.$t('departments.list.dataTable.headers.name'), value: 'name', width: '40%' },
                    { text: this.$t('departments.list.dataTable.headers.activeDemands'), value: 'activeDemands', width: '15%', align: 'center' },
                    { text: this.$t('departments.list.dataTable.headers.demandsCompleted'), value: 'demandsCompleted', width: '15%', align: 'center' },
                    { text: this.$t('departments.list.dataTable.headers.workedHours'), value: 'workedHours', width: '15%', align: 'center' }
                    // {
                    //     text: this.$t('departments.list.dataTable.headers.actions'),
                    //     value: 'actions',
                    //     width: '15%',
                    //     align: 'center',
                    //     sortable: false,
                    //     edit: false,
                    //     delete: false
                    // }
                ],
                items: [],
                showInactives: false,
                totalItems: 0,
                detailTo: '',
                editTo: '',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['name'],
                    sortDesc: [false],
                    sortFormated: [
                        { value: 'name', descending: false }
                    ]
                },
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        '$route': {
            handler: function () {
                this.$nextTick(() => {
                    this.dataTable.detailTo = this.$route.meta.detailTo
                    this.dataTable.editTo = this.$route.meta.edit.route
                    this.dataTable.headers[4].edit = this.$route.meta.options.showEdit
                })
                this.adminOnly()
                this.loadData()
            },
            deep: true
        },
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.showInactives': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.dataTable.detailTo = this.$route.meta.options.detailTo
            this.dataTable.editTo = this.$route.meta.edit.route
        })
        this.adminOnly()
        this.loadData()
    },
    methods: {
        adminOnly () {
            if (this.$helpers.isAdmin()) {
                this.isAdmin = true
                this.dataTable.headers[0].width = '40%'
                // this.dataTable.headers[4].delete = false
            }
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            this.dataTable.loading = true
            this.search.ready = false
            let currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            let endpoint = API.EndPoints.getAllClient
            let params = {
                query: this.search.query,
                limit: this.dataTable.pagination.itemsPerPage,
                skip: this.dataTable.pagination.page - 1,
                order: this.dataTable.pagination.sortFormated,
                showInactives: this.dataTable.showInactives,
                parent: currentUserCompany.client.objectId,
                onlyChild: !this.$route.meta.onlyManaged,
                onlyManaged: this.$route.meta.onlyManaged
            }
            let sortView = {
                showInactives: this.dataTable.showInactives,
                order: this.dataTable.pagination.sortFormated
            }
            new API(endpoint, params).request().then(response => {
                this.$helpers.setClientSortView(sortView)
                this.dataTable.items = response.body.result.results
                this.dataTable.totalItems = response.body.result.count
                this.search.ready = true
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async deleteItem (item) {
            let endpoint = API.EndPoints.removeClient
            let params = {
                objectId: item.objectId,
                userObjectId: item.user.objectId
            }
            let msg = ''
            await new API(endpoint, params).request()
                .then(
                    (resp) => { msg = resp.data.result },
                    (error) => { msg = (error.status !== 0) ? error.data.error : '' }
                )
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
